export default __webpack_public_path__ + "static/media/chinafile-2.022d5450.png";